import request from '@/utils/http';
import { SRM, SRM_FILE,PFX } from '../../constant/constant.js';


// 引用消防分区资源索引选中添加供应商
export const sourcingStorageFireZoneIndexAdd = data => {
    return request({
        url: `${SRM}/sourcingStorageFireZoneIndexAdd`,
        method: 'post',
        data
    });
};

// 引用消防分区资源索引
export const sourcingStorageFireZoneIndexPage = data => {
    return request({
        url: `${SRM}/sourcingStorageFireZoneIndexPage`,
        method: 'post',
        data
    });
};

// 储备供应商装卸引入
export const supplierSourcingLoadAndUnloadDetailImport = params => {
    return request({
        url: `${SRM}/supplierSourcingLoadAndUnloadDetailImport`,
        method: 'get',
        params
    });
};

// 储备供应商装卸添加回访记录
export const supplierSourcingLoadAndUnloadDetailAddRecord = data => {
    return request({
        url: `${SRM}/supplierSourcingLoadAndUnloadDetailAddRecord`,
        method: 'post',
        data
    });
};

// 储备供应商装卸列表导出
export const stevedoreExport = data => {
    return request({
        url: `${SRM_FILE}/exportSupplierSourcingLoadAndUnload`,
        method: 'post',
        data
    });
};

// 寻源过程列表导出
export const supplierSourcingTaskProcessExport = data => {
    return request({
        url: `${SRM_FILE}/supplierSourcingTaskProcessExport`,
        method: 'post',
        data
    });
};

// 储备供应商装卸列表
export const supplierSourcingLoadAndUnloadPage = data => {
    return request({
        url: `${SRM}/supplierSourcingLoadAndUnloadDetail/pageList`,
        method: 'post',
        data
    });
};

// 编辑储备供应商装卸
export const editStevedore = data => {
    return request({
        url: `${SRM}/supplierSourcingLoadAndUnloadDetailEdit`,
        method: 'post',
        data
    });
};

// 新增储备供应商装卸
export const addStevedore = data => {
    return request({
        url: `${SRM}/supplierSourcingLoadAndUnloadDetailAdd`,
        method: 'post',
        data
    });
};

// 寻源过程列表
export const supplierSourcingTaskProcessPage = data => {
    return request({
        url: `${SRM}/supplierSourcingTaskProcessPage`,
        method: 'post',
        data
    });
};

// 寻源终止
export const supplierSourcingTaskProcessFinish = data => {
    return request({
        url: `${SRM}/supplierSourcingTaskProcessFinish`,
        method: 'post',
        data
    });
};

// 寻源过程详情
export const supplierSourcingTaskProcessDetail = params => {
    return request({
        url: `${SRM}/supplierSourcingTaskProcessDetail`,
        method: 'get',
        params
    });
};

// 寻源过程关闭待办
export const supplierSourcingTaskProcessClose = params => {
    return request({
        url: `${SRM}/supplierSourcingTaskProcessClose`,
        method: 'get',
        params
    });
};

// 寻源过程手动关闭单据
export const supplierSourcingTaskProcessHandCloseDoc = params => {
    return request({
        url: `${SRM}/supplierSourcingTaskProcessHandCloseDoc`,
        method: 'get',
        params
    });
};

// 储备资源人资类列表
export const humanResourceList = data => {
    return request({
        url: `${SRM}/selectSupplierSourcingHumanResources/pageList`,
        method: 'post',
        data
    });
};

// 储备资源人资类列表导出
export const exportSupplierSourcingHumanResources = data => {
    return request({
        url: `${SRM_FILE}/exportSupplierSourcingHumanResources`,
        method: 'post',
        data
    });
};

// 储备资源人资类新增
export const supplierSourcingHumanResourcesDetailAdd = data => {
    return request({
        url: `${SRM}/supplierSourcingHumanResourcesDetailAdd`,
        method: 'post',
        data
    });
};

// 储备资源人资类编辑
export const supplierSourcingHumanResourcesDetailEdit = data => {
    return request({
        url: `${SRM}/supplierSourcingHumanResourcesDetailEdit`,
        method: 'post',
        data
    });
};

// 储备资源仓储列表
export const warehouseList = data => {
    return request({
        url: `${SRM}/selectSupplierSourcingStorage/pageList`,
        method: 'post',
        data
    });
};

// 储备资源仓储列表导出
export const exportSupplierSourcingStorage = data => {
    return request({
        url: `${SRM_FILE}/exportSupplierSourcingStorage`,
        method: 'post',
        data
    });
};

// 提交流程接口
export const submitIflow = data => {
    return request({
        url: `${SRM}/supplierSourcingLoadAndUnloadDetail/submit`,
        method: 'post',
        data,
    });
};

// 查询供应商详情
export const getSupplierSourcingLoadDetail = params => {
    return request({
        url: `${SRM}/supplierSourcingLoadAndUnloadDetail/${params.id}`,
        method: 'get',
    });
};

// 引用消防分区资源-删除
export const deleteFireZone = data => {
    return request({
        url: `${SRM}/sourcingStorageDetail/deleteFireZone`,
        method: 'post',
        data,
    });
};

// 仓储新寻源资源-删除
export const storageResourceDelete = data => {
    return request({
        url: `${SRM}/supplierSourcingStorageResource/delete`,
        method: 'DELETE',
        data,
    });
};

// 仓储新寻源资源分页查询
export const storageResourceQueryPage = data => {
    return request({
        url: `${SRM}/supplierSourcingStorageResource/queryPage`,
        method: 'post',
        data,
    });
};

// 仓储新寻源资源-新增
export const storageResourceAdd = data => {
    return request({
        url: `${SRM}/supplierSourcingStorageResource/add`,
        method: 'post',
        data,
    });
};

// 仓储新寻源资源-修改
export const storageResourceModify = data => {
    return request({
        url: `${SRM}/supplierSourcingStorageResource/modify`,
        method: 'put',
        data,
    });
};

// 仓储新寻源资源-导出
export const storageResourceExport = data => {
    return request({
        url: `${SRM_FILE}/supplierSourcingStorageResource/export`,
        method: 'post',
        data,
    });
};

// 仓库寻源-分页
export const queryWarehousePage = data => {
    return request({
        url: `${SRM}/supplierSourcingPhysicsWarehouse/queryPage`,
        // url: `/v50/supplierSourcingPhysicsWarehouse/queryPage`,
        method: 'post',
        data,
    });
};

// 仓库寻源-提交审批
export const submitFlow = data => {
    return request({
        url: `${SRM}/supplierSourcingPhysicsWarehouse/submitFlow`,
        method: 'post',
        data,
    });
};

// 仓库寻源-删除
export const deleteByIdBatch = data => {
    return request({
        url: `${SRM}/supplierSourcingPhysicsWarehouse/deleteByIdBatch`,
        method: 'post',
        data,
    });
};

// 仓库寻源-详情
export const queryDetail = data => {
    return request({
        url: `${SRM}/supplierSourcingPhysicsWarehouse/queryDetail/${data.id}`,
        // url: `/v50/supplierSourcingPhysicsWarehouse/queryDetail/id`,
        method: 'get',
    });
};

// 仓库寻源-编辑
export const modifyWarehouse = data => {
    return request({
        url: `${SRM}/supplierSourcingPhysicsWarehouse/modify`,
        method: 'post',
        data,
    });
};

// 储备资源池-仓储寻源-导出
export const sourcingWarehouseExport = data => {
    return request({
        url: `${SRM_FILE}/supplierSourcingPhysicsWarehouse/export`,
        method: 'post',
        data,
    });
};
